import { createContext, useState, useContext } from "react";

const AddDreamContext = createContext();

export const AddDreamDescProvider = ({ children }) => {
  const [dreamDesc,setDreamDesc] = useState("");

  return (
    <AddDreamContext.Provider value={{ dreamDesc, setDreamDesc }}>
      {children}
    </AddDreamContext.Provider>
  );
};

export const useAddDream = () => useContext(AddDreamContext);
